class GoogleAnalytics {
  track(data: any) {
    const { action, attributes, category, label, isNonInteraction } = data;
    const { value } = (attributes || {});

    if (typeof ga !== 'undefined') {
      ga('send', 'event', category, action, label, value, {
        nonInteraction: isNonInteraction
      });
    }
  }
}

export { GoogleAnalytics };

export default new GoogleAnalytics();
